<template>
  <material-chart-card
    :data="chart.data"
    :options="chart.options"
    color="dover-blue"
    type="Line">
    <h4 class="title font-weight-light">{{ chart.options.title }}</h4>
    <p class="category d-inline-flex font-weight-light">
      <v-icon
        v-if="chart.options.perc >= 0"
        :color="chart.options.color"
        small>
        mdi-arrow-up
      </v-icon>
      <v-icon
        v-else
        :color="chart.options.color"
        small>
        mdi-arrow-down
      </v-icon>
      <span :class="chart.options.perc >= 0 ? chart.options.color+'--text' : chart.options.color+'--text'">{{ Maglink.RoundFormat(chart.options.perc, 2) + '%' }}</span>
    </p>
    <template slot="actions">
      <v-icon
        class="mr-2"
        small>
        mdi-clock-outline
      </v-icon>
      <span class="caption grey--text font-weight-light">updated 4 minutes ago</span>
    </template>
  </material-chart-card>
</template>

<script>
export default {
  props: {
    chart: {
      type: Object,
      required: true,
      default: undefined
    }
  },
  data: () => ({
  })
}
</script>
